import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MaterialTable from "material-table";
import LabelsContext from "../../../../lang/LabelsContext";
import { dateView } from "../../../../utils/Utils";
import { tableIcons } from "../../../system/material-table-utils/MaterialTableUtils";
import TabReviewersService, { TabReviewersServiceType } from "./TabReviewersService";
import { Accordion, AccordionDetails, AccordionSummary } from "./TabReviewersStyle";

export default function TabReviewers() {
  const { Labels } = LabelsContext();
  const { reviewers, expanded, changeExpand }: TabReviewersServiceType = TabReviewersService();

  return (
    <div>
      {reviewers.map(({ id, element }: any) => (
        <Accordion key={id} square expanded={expanded === id} onClick={() => changeExpand(id)}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
            <Typography>{`${Labels.REVISION} #${id}`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MaterialTable
              icons={tableIcons}
              columns={[
                {
                  title: Labels.NAME,
                  render: (rowData: any) => <div>{rowData.reviewer.firstName + " " + rowData.reviewer.lastName}</div>,
                },
                { field: "status", title: Labels.STATUS },
                {
                  field: "selectedOn",
                  title: Labels.SELECTED_ON,
                  render: (rowData: any) => <div>{dateView(rowData.selectedDate)}</div>,
                },
                {
                  field: "mailedOn",
                  title: Labels.MAILED_ON,
                  render: (rowData: any) => <div>{dateView(rowData.mailedDate)}</div>,
                },
                {
                  field: "decidedOn",
                  title: Labels.DECIDED_ON,
                  render: (rowData: any) => <div>{dateView(rowData.decidedDate)}</div>,
                },
                {
                  field: "completedOn",
                  title: Labels.COMPLETED_ON,
                  render: (rowData: any) => <div>{dateView(rowData.completedDate)}</div>,
                },
              ]}
              title={""}
              data={element}
              options={{
                actionsColumnIndex: -1,
                // pageSize: 10,
                paging: false,
              }}
              localization={{
                body: {
                  emptyDataSourceMessage: <Typography>{Labels.NO_REVIEWERS_REVISION}</Typography>,
                },
              }}
              style={{ width: "100%" }}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
